<template>
  <div id="landing-page">
    <h1>Opal Health Medicine</h1>
    <img src="../assets/OHM.png" alt="OHM logo" height="251" width="240" />
  </div>
</template>

<script>
  export default {
    name: 'landing-page',
  }
</script>

<style scoped>
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  div {
    text-align: center;
  }
</style>

